import { ApplicationConfig, ErrorHandler, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { routes } from './app.routes';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { DateTimeProvider, OAuthService, provideOAuthClient } from 'angular-oauth2-oidc';
import { AppConstants } from './app-constants.service';
import { AppState } from './app.state';
import { AuthInterceptor } from './services.module/auth.interceptor';
import { PostErrorHandler } from './post-error-handler';
import { environment } from '../environments/environment';
import { ServerDateTimeService } from './services.module/server-date-time.service';
import { HttpCacheInterceptor } from './services.module/http-cache.interceptor';
import { HttpErrorInterceptor } from './services.module/http-error.interceptor';
import { HttpLoadingInterceptor } from './services.module/http-loading.interceptor';

registerLocaleData(localeDe, 'de', localeDeExtra);

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideOAuthClient(),
        AppConstants,
        AppState,
        { provide: ErrorHandler, useClass: PostErrorHandler },
        { provide: APP_BASE_HREF, useValue: environment.baseHref },
        { provide: LOCALE_ID, useValue: 'de' },
        { provide: DateTimeProvider, useClass: ServerDateTimeService },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpLoadingInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
            deps: [OAuthService]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpCacheInterceptor,
            multi: true
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
};
